export default __webpack_public_path__ + "static/media/Purple-Bg.ccbc019c.png";